import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { app } from '../firebase';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'

function DriverTripsPage() {
  const { uid } = useParams();
  const db = getFirestore(app);
  const [trips, setTrips] = useState([]);

  useEffect(() => {
    const fetchTrips = async () => {
      const q = query(collection(db, 'Orders'), where('driverId', '==', uid));
      const snapshot = await getDocs(q);
      const tripsData = [];
      snapshot.forEach(doc => tripsData.push({ id: doc.id, ...doc.data() }));
      setTrips(tripsData);
    };
    fetchTrips();
  }, [db, uid]);

  return (
    <div className='contentMain'> 
        <LeftBar/>
        <div className='theRightOne'> 
          <div className='DashTop'>
            <h1>Driver Trips</h1>
            <NavBar/>
          </div>
    <div className="p-4">
      <h5>All Orders</h5>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>From</th>
            <th>To</th>
            <th>Status</th>
            <th>Feedback</th>
          </tr>
        </thead>
        <tbody>
          {trips.map(trip => (
            <tr key={trip.id}>
              <td>{trip.fromLocation || 'N/A'}</td>
              <td>{trip.toLocation || 'N/A'}</td>
              <td>{trip.status}</td>
              <td>{trip.feedback || '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
    </div>
    </div>

  );
}

export default DriverTripsPage;